<template>
  <div id="item-go-checkin-review">
    <vx-card class="mt-3 position-relative">
      <div style="position: absolute; top: 20px; right: 20px;">
        <vs-button color="success" class="p-2 px-3" @click="viewDetail(reviewData)">View detail</vs-button>
      </div>
      <vs-row class="font-medium flex justify-between">
        <div class="pb-3 flex justify-center md:justify-start">
          <div v-if="reviewData.avatar != null">
            <vs-avatar size="55px" :src="reviewData.avatar"/>
          </div>
          <div v-else>
            <vs-avatar size="55px" :text="StringHelper.changeFormatAvatar(reviewData.user_name)" class="text-3xl"/>
          </div>

          <div class="flex flex-col md:ml-6 ml-0 justify-around">
            <div class="font-bold mt-3 mb-3 text-lg flex align-center mx-auto md:ml-0">
              <span class="color-black">{{reviewData.user_name}}</span>
              <img src="../../../assets/images/logo/newlogo.png" width="30" height="30" class="ml-4" style="margin-top: 1.5px"/>
            </div>
            <vs-alert v-if="reviewData.customer" class="flex align-center justify-center mb-6" :color="getMemberTypeColor(reviewData.customer.type)" style="width: 70px; height: 30px !important">{{reviewData.customer.type}}</vs-alert>
            <div :class="{'mt-4': !reviewData.customer}">
              <span class="vs-col w-1/2 mb-3">
                <feather-icon icon="PhoneIcon" svgClasses="w-4 h-4 stroke-current" class="w-1/6" :class="{'w-1/12': reviewData.customer}"/>
                <span v-if="reviewData.customer">{{StringHelper.phoneNumberFormat(reviewData.customer.phone)}}</span>
                <span v-else>N/A</span>
              </span>
              <span class="vs-col w-1/2 mb-3">
                Last visit:
                <span v-if="reviewData.customer">{{changeFormat(reviewData.customer.last_visited)}}</span>
                <span v-else class="pr-6">N/A</span>
              </span>
              <span class="vs-col w-1/2">
                <feather-icon icon="MailIcon" svgClasses="w-4 h-4 stroke-current" class="w-1/6" :class="{'w-1/12': reviewData.customer}"/>
                <span class="d-inline-block" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap; transform: translateY(4px)" v-if="reviewData.customer">{{reviewData.customer.email}}</span>
                <span class="d-inline-block" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap; transform: translateY(4px)" v-else>N/A</span>
              </span>
              <span class="vs-col w-1/2">
                Visit
                <span v-if="reviewData.customer">{{reviewData.customer.visit_count}}</span>
                <span v-else>N/A</span> times
              </span>
            </div>
          </div>
        </div>
      </vs-row>
      <vs-divider></vs-divider>
      <div>
        <vs-row class="font-medium py-3 flex align-center">
          <img src="../../../assets/images/logo/newlogo.png" class="ml-1"/>
          <span class="font-bold ml-4 text-lg color-black">Go-Checkin Reviews</span>
        </vs-row>

        <div class="ml-1">
          <div class="flex align-center mb-2">
            <!-- <vs-icon icon="sentiment_very_satisfied" size="medium" v-if="reviewData.rating == 5"></vs-icon>
            <vs-icon icon="sentiment_dissatisfied" size="medium" v-if="reviewData.rating == 3"></vs-icon>
            <vs-icon icon="sentiment_very_dissatisfied" size="medium" v-if="reviewData.rating == 1"></vs-icon> -->
            <div class="emotional-item" v-if="reviewData.rating == 1">
                <div class="emotional-icon">
                    <vs-button class="emotional-btn very-unhappy emotional-active">
                        <span></span>
                    </vs-button>
                </div>
            </div>
            <div class="emotional-item" v-if="reviewData.rating == 2">
                <div class="emotional-icon">
                    <vs-button class="emotional-btn unhappy emotional-active">
                        <span></span>
                    </vs-button>
                </div>
            </div>

            <div class="emotional-item" v-if="reviewData.rating == 3">
                <div class="emotional-icon">
                    <vs-button class="emotional-btn normal emotional-active">
                        <span></span>
                    </vs-button>
                </div>
            </div>

            <div class="emotional-item" v-if="reviewData.rating == 4">
                <div class="emotional-icon">
                    <vs-button class="emotional-btn happy emotional-active">
                        <span></span>
                    </vs-button>
                </div>
            </div>

            <div class="emotional-item" v-if="reviewData.rating == 5">
                <div class="emotional-icon">
                    <vs-button class="emotional-btn very-happy emotional-active">
                        <span></span>
                    </vs-button>
                </div>
            </div>
            <span class="text-xl ml-1" style="line-height: 1">{{changeFormat(reviewData.time_create)}}</span>
          </div>
          <div class="ml-1" style="line-height: 1.5">
            {{reviewData.content}}
          </div>
        </div>
      </div>

      <div class="mt-6">
        <vs-button color="success" class="p-1 px-3" @click="Reply">Reply</vs-button>
      </div>
    </vx-card>
    <popup-reply
      :popupConfig="popupConfig"
      :reviewData="reviewData"
      :key="reply_key"
    >
    </popup-reply>
    <customer-popup-content
      v-if="customer_key != 0"
      :popupConfig="popupCustomerConfig"
      :activeCustomer="activeCustomer"
      :key="customer_key + 'a'"
      @ClosePopup="popupCustomerConfig.isOpen = false"
      :isFromReview="true"
    ></customer-popup-content>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import { StringHelper } from "../../../models/string_helper";
import {changeFormatHelper} from '../../../helper/datetimeHelper';
export default {
  name: "item-go-checkin-review",
  components: {
    StarRating,
  },
  props: {
    reviewData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      popupConfig:{
        isOpen : false,
      },
      StringHelper,
      reply_key: 0,
      customer_key: 0,
      popupCustomerConfig: {
        isOpen: false
      },
      activeCustomer: null,
    };
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
    },
    Reply() {
      this.popupConfig.isOpen = true;
      this.reply_key++;
      // this.openLoadingInDiv();
      // this.$store.dispatch('reviewList/CHECK_REVIEW_REPLY_PERMISSION').then((res) => {
      //   this.closeLoading();
      //   if(res == 1) {
      //     this.popupConfig.isOpen = true;
      //     this.reply_key++;
      //   } else {
      //     this.$vs.dialog({
      //       color: "warning",
      //       title: "Notification",
      //       text: "Please call us at 832-968-6668 to activate this feature. Thanks!",
      //       acceptText: "OK"
      //     });
      //   }
      // }).catch((err) => {
      //   console.log('Error: ', err);
      //   this.closeLoading();
      //   this.$vs.dialog({
      //     color: 'danger',
      //     title: 'Notification',
      //     text: 'Check review reply permission failed',
      //     acceptText: 'OK'
      //   })
      // })      
    },
    changeFormat(day){
      if(day) {
        return changeFormatHelper(day);
      } else {
        return 'N/A';
      }
    },
    getMemberTypeColor(member_type) {
      if (member_type == "new") return "success";
      if (member_type == "atrisk") return "warning";
      if (member_type == "vip") return "danger";
      if (member_type == "regular") return "primary";
      return "dark";
    },
    viewDetail(item) {
      console.log(item);
      if(item && item.customer) {
        let customer = {
          id: item.customer.id,
          full_name: item.customer.full_name,
          type: item.customer.type,
          visit_count: item.customer.visit_count,
          last_visited: item.customer.last_visited,
          lifetime_point: item.customer.lifetime_point,
          current_point: item.customer.current_point,
          is_send_sms: item.customer.is_send_sms,
          email: item.customer.email,
          create_at: item.customer.create_at,
          phone: item.customer.phone
        }
        this.activeCustomer = customer;
        this.popupCustomerConfig.isOpen = true;
        this.customer_key++;
      }
    }
  }
};
</script>
